import { lazy } from 'react';

/* eslint-disable id-length */
import { isAdelphi } from '#models/tenant';

import { ROLES } from './users';

const Home = lazy(() => import('#screens/Home'));
const ErrorScreen = lazy(() => import('#screens/ErrorScreen'));
const Products = lazy(() => import('#screens/Products'));
const Login = lazy(() => import('#screens/Login'));
const LoginRedirect = lazy(() => import('#screens/LoginRedirect'));
const Records = lazy(() => import('#screens/Records'));
const AdelphiMainMenu = lazy(() => import('#screens/AdelphiMainMenu'));
const AdelphiProductionMenu = lazy(() => import('#screens/AdelphiProductionMenu'));
const AdelphiChecklistsMenu = lazy(() => import('#screens/AdelphiChecklistsMenu'));
const AdelphiSpiritMenu = lazy(() => import('#screens/AdelphiSpiritMenu'));
const AdelphiFeints = lazy(() => import('#screens/AdelphiFeints'));
const AdelphiCaskFillings = lazy(() => import('#screens/AdelphiCaskFillings'));
const AdelphiCaskFillingById = lazy(() => import('#screens/AdelphiCaskFillingById'));
const AdelphiStatements = lazy(() => import('#screens/AdelphiStatements'));
const AdelphiStatementsMashingAndFermentation = lazy(() =>
  import('#screens/AdelphiStatementsMashingAndFermentation')
);
const AdelphiStatementsSpiritAndFeints = lazy(() => import('#screens/AdelphiStatementsSpiritAndFeints'));
const AdelphiSpiritReductions = lazy(() => import('#screens/AdelphiSpiritReductions'));
const AdelphiDailyAMStillsChecklists = lazy(() => import('#screens/AdelphiDailyAMStillsChecklists'));
const AdelphiDailyPMStillsChecklists = lazy(() => import('#screens/AdelphiDailyPMStillsChecklists'));
const AdelphiDailyAMMashChecklists = lazy(() => import('#screens/AdelphiDailyAMMashChecklists'));
const AdelphiDailyPMMashChecklists = lazy(() => import('#screens/AdelphiDailyPMMashChecklists'));
const AdelphiWeeklyStillsChecklists = lazy(() => import('#screens/AdelphiWeeklyStillsChecklists'));
const AdelphiWeeklyMashChecklists = lazy(() => import('#screens/AdelphiWeeklyMashChecklists'));

export const ROUTES = {
  ADELPHI_MAIN_MENU: {
    path: '/admin/menu',
    basePath: '/admin/menu',
    exact: true,
    supportedRoles: [ROLES.USER, ROLES.ADMIN],
    component: AdelphiMainMenu,
    validateByTenant: () => true
  },
  RECORDS: {
    path: '/admin/records',
    basePath: '/admin/records',
    exact: true,
    supportedRoles: [ROLES.USER, ROLES.ADMIN],
    component: Records,
    validateByTenant: () => true
  },
  ADELPHI_PRODUCTION_MENU: {
    path: '/admin/production_menu',
    basePath: '/admin/production_menu',
    exact: true,
    supportedRoles: [ROLES.USER, ROLES.ADMIN],
    component: AdelphiProductionMenu,
    validateByTenant: isAdelphi
  },
  ADELPHI_SPIRIT_MENU: {
    path: '/admin/spirit',
    basePath: '/admin/spirit',
    exact: true,
    supportedRoles: [ROLES.USER, ROLES.ADMIN],
    component: AdelphiSpiritMenu,
    validateByTenant: isAdelphi
  },
  ADELPHI_CHECKLISTS_MENU: {
    path: '/admin/checklists',
    basePath: '/admin/checklists',
    exact: true,
    supportedRoles: [ROLES.USER, ROLES.ADMIN],
    component: AdelphiChecklistsMenu,
    validateByTenant: isAdelphi
  },
  ADELPHI_DAILY_AM_STILLS_CHECKLISTS: {
    path: '/admin/checklists/daily-am-stills',
    basePath: '/admin/checklists/daily-am-stills',
    exact: true,
    supportedRoles: [ROLES.USER, ROLES.ADMIN],
    component: AdelphiDailyAMStillsChecklists,
    validateByTenant: isAdelphi
  },
  ADELPHI_DAILY_PM_STILLS_CHECKLISTS: {
    path: '/admin/checklists/daily-pm-stills',
    basePath: '/admin/checklists/daily-pm-stills',
    exact: true,
    supportedRoles: [ROLES.USER, ROLES.ADMIN],
    component: AdelphiDailyPMStillsChecklists,
    validateByTenant: isAdelphi
  },
  ADELPHI_DAILY_AM_MASH_CHECKLISTS: {
    path: '/admin/checklists/daily-am-mash',
    basePath: '/admin/checklists/daily-am-mash',
    exact: true,
    supportedRoles: [ROLES.USER, ROLES.ADMIN],
    component: AdelphiDailyAMMashChecklists,
    validateByTenant: isAdelphi
  },
  ADELPHI_DAILY_PM_MASH_CHECKLISTS: {
    path: '/admin/checklists/daily-pm-mash',
    basePath: '/admin/checklists/daily-pm-mash',
    exact: true,
    supportedRoles: [ROLES.USER, ROLES.ADMIN],
    component: AdelphiDailyPMMashChecklists,
    validateByTenant: isAdelphi
  },
  ADELPHI_WEEKLY_STILLS_CHECKLISTS: {
    path: '/admin/checklists/weekly-stills',
    basePath: '/admin/checklists/weekly-stills',
    exact: true,
    supportedRoles: [ROLES.USER, ROLES.ADMIN],
    component: AdelphiWeeklyStillsChecklists,
    validateByTenant: isAdelphi
  },
  ADELPHI_WEEKLY_MASH_CHECKLISTS: {
    path: '/admin/checklists/weekly-mash',
    basePath: '/admin/checklists/weekly-mash',
    exact: true,
    supportedRoles: [ROLES.USER, ROLES.ADMIN],
    component: AdelphiWeeklyMashChecklists,
    validateByTenant: isAdelphi
  },
  ADELPHI_FEINTS: {
    path: '/admin/feints',
    basePath: '/admin/feints',
    exact: true,
    supportedRoles: [ROLES.USER, ROLES.ADMIN],
    component: AdelphiFeints,
    validateByTenant: isAdelphi
  },
  ADELPHI_SPIRIT_REDUCTIONS: {
    path: '/admin/spirit-reductions',
    basePath: '/admin/spirit-reductions',
    exact: true,
    supportedRoles: [ROLES.USER, ROLES.ADMIN],
    component: AdelphiSpiritReductions,
    validateByTenant: isAdelphi
  },
  ADELPHI_CASK_FILLINGS: {
    path: '/admin/cask-fillings',
    basePath: '/admin/cask-fillings',
    exact: true,
    supportedRoles: [ROLES.USER, ROLES.ADMIN],
    component: AdelphiCaskFillings,
    validateByTenant: isAdelphi
  },
  ADELPHI_CASK_FILLING_BY_ID: {
    path: '/admin/cask-fillings/:id',
    basePath: '/admin/cask-fillings',
    exact: true,
    strict: false,
    supportedRoles: [ROLES.USER, ROLES.ADMIN],
    component: AdelphiCaskFillingById,
    validateByTenant: isAdelphi
  },
  ADELPHI_STATEMENTS: {
    path: '/admin/statements',
    basePath: '/admin/statements',
    exact: true,
    supportedRoles: [ROLES.USER, ROLES.ADMIN],
    component: AdelphiStatements,
    validateByTenant: isAdelphi
  },
  ADELPHI_STATEMENT_BY_ID_MASHING_AND_FERMENTATION: {
    path: '/admin/statements/:id/mashing-and-fermentation',
    basePath: '/admin/statements',
    exact: true,
    strict: false,
    supportedRoles: [ROLES.USER, ROLES.ADMIN],
    component: AdelphiStatementsMashingAndFermentation,
    validateByTenant: isAdelphi
  },
  ADELPHI_STATEMENT_BY_ID_SPIRIT_AND_FEINTS: {
    path: '/admin/statements/:id/spirit-and-feints',
    basePath: '/admin/statements',
    exact: true,
    strict: false,
    supportedRoles: [ROLES.USER, ROLES.ADMIN],
    component: AdelphiStatementsSpiritAndFeints,
    validateByTenant: isAdelphi
  },
  HOME: {
    path: '/',
    basePath: '/',
    exact: true,
    publicRoute: true,
    supportedRoles: [ROLES.USER, ROLES.ADMIN],
    component: Home
  },
  ERROR: {
    path: '/error',
    basePath: '/error',
    publicRoute: true,
    supportedRoles: [ROLES.USER, ROLES.ADMIN],
    exact: true,
    component: ErrorScreen
  },
  PRODUCTS: {
    path: '/admin/products',
    basePath: '/admin/products',
    publicRoute: false,
    supportedRoles: [ROLES.USER, ROLES.ADMIN],
    exact: true,
    component: Products
  },
  LOGIN_REDIRECT: {
    path: '/login_redirect',
    basePath: '',
    loginRoute: true,
    supportedRoles: [ROLES.USER, ROLES.ADMIN],
    exact: false,
    component: LoginRedirect
  },
  LOGIN: {
    path: '/login',
    basePath: '',
    loginRoute: true,
    supportedRoles: [ROLES.USER, ROLES.ADMIN],
    exact: false,
    component: Login
  }
};

export const BASE_PATHS = [ROUTES.ERROR.basePath, ROUTES.PRODUCTS.basePath];

export const DEFAULT_ROUTE_PATH = {
  [ROLES.USER]: ROUTES.HOME.path,
  [ROLES.ADMIN]: ROUTES.HOME.path
};

export const MANUAL_SENTRY_ROUTES = [
  { path: '/admin/products' },
  { path: '/login_redirect' },
  { path: '/login' },
  { path: '/' }
];
